import type { LandingPageContent } from '../types'

export const INSTALACJA_ELEKTRYCZNA_FOTOWOLTAIKI: LandingPageContent = {
  slug: 'instalacja-elektryczna-fotowoltaiki',
  lang: 'pl',
  topicId: 'photovoltaik-elektroinstallation',
  title: 'Instalacja elektryczna fotowoltaiki – fachowe podłączenie',
  metaDescription:
    'Panele zamontowane, brakuje podłączenia elektrycznego? Zapytaj wyłącznie o instalację ' +
    'elektryczną: falownik, magazyn energii, zgłoszenie do operatora.',
  keywords: [
    'instalacja elektryczna fotowoltaiki',
    'podłączenie instalacji fotowoltaicznej',
    'montaż falownika fotowoltaicznego',
    'zgłoszenie fotowoltaiki do operatora sieci',
    'elektryk do instalacji fotowoltaicznej',
  ],
  eyebrow: 'Tylko podłączenie elektryczne',
  h1: 'Fachowe podłączenie instalacji fotowoltaicznej',
  intro:
    'Panele są już zamontowane, ale brakuje podłączenia elektrycznego? Do części elektrycznej w ' +
    'Niemczech konieczna jest wykwalifikowana firma elektryczna - między innymi do zgłoszenia u ' +
    'operatora sieci. W Roofora możesz zapytać o tę usługę jako osobny typ zapytania, bez potrzeby ' +
    'kompletnego systemu.',
  sections: [
    { type: 'heading', text: 'Dla kogo opłaca się zapytanie tylko o instalację elektryczną' },
    {
      type: 'list',
      items: [
        'Panele są już zamontowane (np. przez Ciebie samego lub inną firmę) i brakuje tylko podłączenia elektrycznego',
        'Chcesz domontować magazyn energii lub falownik',
        'Czeka Cię jeszcze wymiana licznika lub zgłoszenie do operatora sieci',
      ],
    },
    { type: 'heading', text: 'Co może obejmować instalacja elektryczna' },
    {
      type: 'list',
      items: [
        'Podłączenie i uruchomienie falownika',
        'Domontaż magazynu energii o wybranej wielkości',
        'Dostosowanie lub wymiana rozdzielnicy',
        'Zgłoszenie i uruchomienie u Twojego operatora sieci',
      ],
    },
    { type: 'heading', text: 'Tak przebiega zapytanie o instalację elektryczną' },
    {
      type: 'paragraph',
      text:
        'Podajesz, jaki sprzęt jest już na miejscu, czy potrzebny jest magazyn energii lub falownik i ' +
        'czy czeka Cię wymiana licznika. Firmy rzemieślnicze z kwalifikacją elektryczną widzą Twoje ' +
        'anonimowe zapytanie i składają niewiążące oferty tylko na usługę instalacji.',
    },
    { type: 'heading', text: 'Kontakt dopiero po Twojej zgodzie' },
    {
      type: 'paragraph',
      text:
        'Jak przy każdym typie zapytania w Roofora, kontakt nawiązywany jest dopiero wtedy, gdy ' +
        'indywidualnie zgodzisz się na konkretną firmę - bez zbiorowej zgody, bez lawiny telefonów.',
    },
  ],
  faq: [
    {
      q: 'Czy instalację elektryczną musi koniecznie wykonać firma specjalistyczna?',
      a: 'Tak - podłączenie elektryczne i zgłoszenie do operatora sieci muszą w Niemczech zostać wykonane przez zarejestrowaną firmę elektryczną.',
    },
    {
      q: 'Czy mogę zapytać tylko o domontaż magazynu energii, bez innych prac?',
      a: 'Tak - w zapytaniu podaj po prostu pożądaną wielkość magazynu energii, pozostałe dane o istniejącym sprzęcie są opcjonalne.',
    },
    {
      q: 'Potrzebuję tylko nowego falownika, bez innych prac - czy to możliwe?',
      a: 'Tak - "Czy sprzęt (falownik/magazyn) jest już zainstalowany?" to opcjonalne pole w zapytaniu. Wystarczy podać, że potrzebny jest falownik, resztę danych o istniejącej instalacji można pozostawić puste.',
    },
  ],
  primaryCta: { label: 'Zapytaj o instalację elektryczną', action: 'customer' },
  secondaryCta: { label: 'Potrzebujesz tylko montażu na dachu?', action: 'link', href: '/montaz-paneli-fotowoltaicznych' },
  relatedLinks: [
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Zaplanuj instalację krok po kroku', href: '/zaplanuj-instalacje-fotowoltaiczna' },
    { label: 'Wallbox i samochód elektryczny z nadwyżką solarną', href: '/fotowoltaika-wallbox-samochod-elektryczny' },
  ],
}
